import React from "react";

function ExpMarquee() {
  return (
    <div className="overflow-hidden bg-[#C8F135] py-2 sm:py-3">
      <div className="flex w-max whitespace-nowrap animate-[mq-exp_16s_linear_infinite]">
        {[...Array(20)].map((_, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-2 px-3 font-pixeloperator text-3xl tracking-[1px] text-[#1a1a1a] sm:gap-3 sm:px-4 sm:text-4xl sm:tracking-[2px] md:px-5 md:text-5xl lg:px-6"
          >
            experience

            <img
              src="/star.svg"
              alt=""
              className="h-5 w-5 shrink-0 select-none sm:h-6 sm:w-6 md:h-7 md:w-7 lg:h-8 lg:w-8"
              draggable={false}
            />
          </span>
        ))}
      </div>

      <style>{`
        @keyframes mq-exp {
          from {
            transform: translateX(0);
          }

          to {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </div>
  );
}

export default ExpMarquee;